import { render, staticRenderFns } from "./_formBonificarPRO.vue?vue&type=template&id=1fd8d04f&scoped=true"
import script from "./_formBonificarPRO.vue?vue&type=script&lang=ts"
export * from "./_formBonificarPRO.vue?vue&type=script&lang=ts"
import style0 from "./_formBonificarPRO.vue?vue&type=style&index=0&id=1fd8d04f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd8d04f",
  null
  
)

export default component.exports